import { COLOR_PALETTE } from 'constants/ui';

const TYPE_CHIP_PALETTE = {
  'T-FN': { color: COLOR_PALETTE.PURPLE[7], backgroundColor: COLOR_PALETTE.PURPLE[2] },
  'T-ENUM': { color: COLOR_PALETTE.MAGENTA[7], backgroundColor: COLOR_PALETTE.MAGENTA[2] },
  'T-STRING': { color: COLOR_PALETTE.ORANGE[7], backgroundColor: COLOR_PALETTE.ORANGE[2] },
  'T-NUMBER': { color: COLOR_PALETTE.BLUE[7], backgroundColor: COLOR_PALETTE.BLUE[2] },
  'T-DATE': { color: COLOR_PALETTE.RED[7], backgroundColor: COLOR_PALETTE.RED[2] },
  'T-BOOL': { color: COLOR_PALETTE.GREEN[7], backgroundColor: COLOR_PALETTE.GREEN[2] },
  'T-ENTITY': { color: COLOR_PALETTE.BLUE_GRAY[7], backgroundColor: COLOR_PALETTE.BLUE_GRAY[2] },
  'T-ARRAY': { color: COLOR_PALETTE.CYAN[7], backgroundColor: COLOR_PALETTE.CYAN[2] },
  'T-ITERATOR': { color: COLOR_PALETTE.LIME[7], backgroundColor: COLOR_PALETTE.LIME[2] },
  'T-NEUTRAL': {
    color: ({ palette }) => palette.text.secondary,
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const popoverStyles = anchor => ({
  position: 'absolute',
  zIndex: 30,
  left: `${anchor.left}px`,
  top: `${anchor.top}px`,
  width: '430px',
  maxWidth: 'calc(100% - 12px)',
  maxHeight: '330px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  fontSize: '13px',
  backgroundColor: ({ palette }) => palette.background.paper,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '10px',
  boxShadow: ({ palette }) => palette.shadow.s,
});

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 11px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  fontSize: '12px',
  color: ({ palette }) => palette.text.secondary,
};

export const typedChipStyles = {
  fontFamily: 'monospace',
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '5px',
  padding: '1px 6px',
  color: ({ palette }) => palette.text.primary,
};

export const scopeRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  flexWrap: 'wrap',
  padding: '6px 11px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  fontSize: '11px',
  color: ({ palette }) => palette.text.secondary,
};

export const scopeCollectionStyles = {
  fontWeight: 700,
  color: ({ palette }) => palette.success.main,
};

export const scopeIteratorStyles = {
  fontFamily: 'monospace',
};

export const listStyles = {
  overflowY: 'auto',
  padding: '4px 0',
};

export const groupHeaderStyles = {
  position: 'sticky',
  top: 0,
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  fontSize: '10px',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  fontWeight: 700,
  padding: '6px 12px 4px',
  color: ({ palette }) => palette.text.secondary,
};

export const groupHintStyles = {
  marginLeft: 'auto',
  textTransform: 'none',
  letterSpacing: 0,
  fontWeight: 500,
  fontStyle: 'italic',
  color: ({ palette }) => palette.text.link,
};

export const getOptionRowStyles = isActive => ({
  display: 'flex',
  alignItems: 'center',
  gap: '9px',
  padding: '7px 12px',
  cursor: 'pointer',
  backgroundColor: ({ palette }) => (isActive ? palette.info.soft : 'transparent'),
  '&:hover': {
    backgroundColor: ({ palette }) => (isActive ? palette.info.soft : palette.background.secondary),
  },
});

export const getTypeChipStyles = chip => ({
  flexShrink: 0,
  fontSize: '9.5px',
  fontWeight: 700,
  borderRadius: '5px',
  padding: '2px 6px',
  ...(TYPE_CHIP_PALETTE[chip] ?? TYPE_CHIP_PALETTE['T-NEUTRAL']),
});

export const labelStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'baseline',
  gap: '6px',
  flexWrap: 'wrap',
};

export const nameStyles = {
  fontFamily: 'monospace',
  fontSize: '12.5px',
  color: ({ palette }) => palette.text.primary,
  '& mark': {
    backgroundColor: ({ palette }) => palette.background.highlight,
    borderRadius: '2px',
    color: 'inherit',
  },
};

export const signatureStyles = {
  fontFamily: 'monospace',
  fontSize: '11px',
  color: ({ palette }) => palette.text.secondary,
};

export const descriptionStyles = {
  fontSize: '11.5px',
  color: ({ palette }) => palette.text.secondary,
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexWrap: 'wrap',
  padding: '7px 11px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
  fontSize: '11px',
  color: ({ palette }) => palette.text.secondary,
};

export const keycapStyles = {
  fontFamily: 'monospace',
  fontSize: '11px',
  lineHeight: 1,
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderBottomWidth: '2px',
  borderRadius: '5px',
  padding: '3px 5px',
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.secondary,
};
